import script from "./Camera.vue?vue&type=script&setup=true&lang=js"
export * from "./Camera.vue?vue&type=script&setup=true&lang=js"

import "./Camera.vue?vue&type=style&index=0&id=fc8071b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc8071b6"]])

export default __exports__